const n="\n  id\n  key\n  namespace\n  type\n  value\n";export{n as STOREFRONT_METAFIELD_FRAGMENT};
//# sourceMappingURL=metafields.js.map
